import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { FaUserShield, FaBrain, FaLayerGroup, FaMicrochip, FaUserAstronaut, FaBug, FaUsers, FaPaperPlane } from "react-icons/fa";
import '../styles/Career.css';
import Seo from "../seo/Seo";

const MailLink = ({ children }) => (
  <a href="mailto:hello@malilabs.com" className="fw-bold">{children}</a>
);

const Career = () => {
  const { t } = useTranslation();
  const ROLE_ICONS = [<FaBrain className="service-icon" />, <FaLayerGroup className="service-icon" />, <FaBug className="service-icon" />];
  const positions = t('career.positions').map((job, i) => ({ ...job, icon: ROLE_ICONS[i] }));
  const PERK_ICONS = [
    <FaUserShield size={40} className="text-info mb-3 yolo-float" />,
    <FaMicrochip size={40} className="text-primary mb-3 yolo-float" />,
    <FaUsers size={40} className="text-success mb-3 yolo-float" />
  ];
  const perks = t('career.perks').map((perk, i) => ({ ...perk, icon: PERK_ICONS[i] }));

  return (
    <div className="career-page">
      <Seo page="career" path="/career" />
      <section className="career-hero py-5">
        <div className="container text-center">
          <div className="mb-4">
            <FaUserAstronaut size={80} className="text-primary yolo-pulse" />
          </div>
          <h1 className="font-weight-bold mb-3">{t('career.hero.title')}</h1>
          <p className="lead text-muted mx-auto" style={{ maxWidth: "600px" }}>
            {t('career.hero.text')}
          </p>
        </div>
      </section>

      <section id="open-roles" className="career-roles py-5 bg-light">
        <div className="container">
          <div className="heading_container d-flex justify-content-center mb-5">
            <h2>{t('career.rolesTitle')}</h2>
          </div>
          <div className="row g-4 justify-content-center">
            {positions.map((job, index) => (
              <div key={index} className="col-lg-4 col-md-6 mb-4">
                <div className="modern-service-card h-100 p-4 shadow-sm border-0 rounded-4 transition-hover text-center d-flex flex-column">
                  <div className="icon-wrapper mb-3 icon-gradient-bg rounded-circle d-inline-flex align-items-center justify-content-center p-3 mx-auto">
                    {job.icon}
                  </div>
                  <h4 className="font-weight-bold mb-2">{job.title}</h4>
                  <div>
                    <span className="badge badge-soft-primary px-3 py-2 rounded-pill mb-3">{t('career.type')}</span>
                  </div>
                  <p className="text-muted lh-lg flex-grow-1 mb-0">{job.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="career-apply py-5 text-center">
        <div className="container">
           <div className="p-5 bg-white rounded-4 shadow-sm transition-hover" style={{ border: '2px dashed #42a5f5' }}>
             <FaPaperPlane size={40} className="text-info mb-3 yolo-float" />
             <h3 className="font-weight-bold mb-3">{t('career.apply.title')}</h3>
             <p className="lead text-muted mb-0 mx-auto" style={{ maxWidth: "700px" }}>
               {t('career.apply.line1')} <br/><br/>
               <Trans
                 i18nKey="career.apply.line2"
                 components={{ 1: <MailLink /> }}
               /> <br/>
               {t('career.apply.line3')}
             </p>
           </div>
        </div>
      </section>

      <section className="career-perks py-5 mb-5">
        <div className="container text-center">
          <div className="heading_container d-flex justify-content-center mb-5">
            <h2>{t('career.perksTitle')}</h2>
          </div>
          <div className="row g-4 mt-3">
            {perks.map((perk, i) => (
              <div key={i} className="col-md-4">
                {perk.icon}
                <h4>{perk.title}</h4>
                <p className="text-muted">{perk.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Career;